import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const abePutStylistStripeAccount = actionEndpointBe(
  'abePutStylistStripeAccount',
  H.put,
  'payments/stripe/setup/stylist/account/:salonId/:stylistId/',
  (options, extra) => ({
    ...options,
    data: extra?.data,
    params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
    umsg: UMSG_TYPE.global,
  }),
);

export const ibePutStylistStripeAccount = actionEndpointBe(
  'ibePutStylistStripeAccount',
  H.put,
  'payments/stripe/setup/stylist/account/:salonId/:stylistId/',
  (options, extra) => ({
    ...options,
    inert: true,
    data: extra?.data,
    params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
    umsg: UMSG_TYPE.global,
  }),
);

export const bePutStylistStripeAccount = actionBe(
  'bePutStylistStripeAccount',
  withOptions(({ AT, ATAG, stylistId, data }) =>
    endpoint(H.patch, 'payments/stripe/setup/stylist/account/:salonId/:stylistId/', {
      AT,
      name: ATAG,
      params: { stylistId },
      data,
    }),
  ),
);
